import React, { useState } from 'react';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What areas do you serve?',
      answer: 'We serve the Greater Tampa Bay area including Pinellas, Hillsborough, Pasco, Hernando, Polk, and Manatee counties. Not sure if we cover your area? Give Joe a call at (727) 277-3366 to find out!',
    },
    {
      question: 'How quickly can you respond to a service request?',
      answer: 'We typically respond to inquiries within 24 hours and can often schedule service within a few days, depending on the urgency and scope of work. For emergency situations, we prioritize quick response times.',
    },
    {
      question: 'Do you offer free estimates?',
      answer: 'Yes! We provide free, no-obligation consultations and estimates. Joe will assess your pond or lake, discuss your specific needs, and provide a detailed quote for the recommended services.',
    },
    {
      question: 'Are your treatments safe for fish and pets?',
      answer: 'Absolutely. We only use treatments approved by the Florida Department of Agriculture that are safe for fish, pets, and wildlife when applied correctly. We always follow label directions and best practices to protect your aquatic ecosystem.',
    },
    {
      question: 'How often does a pond or lake need maintenance?',
      answer: "It varies based on size, location, and usage. Most ponds benefit from monthly maintenance, while some may only need quarterly treatments. We'll recommend a schedule based on your specific situation.",
    },
    {
      question: 'Do you handle both residential and commercial properties?',
      answer: 'Yes! We work with homeowners, HOAs, CDDs, property managers, commercial businesses, and developers. No project is too big or too small.',
    },
    {
      question: 'What should I do if I notice sudden algae growth?',
      answer: 'Contact us right away! Rapid algae growth can indicate water quality issues. The sooner we address it, the easier and more cost-effective the treatment. Call Joe at (727) 277-3366 for prompt service.',
    },
    {
      question: 'Are you licensed and insured?',
      answer: 'Yes, we are fully licensed by the Florida Department of Agriculture for aquatic weed control and carry comprehensive insurance. We stay current with continuing education to maintain knowledge of the latest methods and regulations.',
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="bg-slate-50 py-8 md:py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-900 text-center mb-4">
          Frequently Asked Questions
        </h2>
        <p className="text-xl text-brand-700 text-center mb-12 max-w-2xl mx-auto">
          Get answers to common questions about our pond and lake management services
        </p>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-brand-100"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full text-left px-6 py-4 flex justify-between items-center hover:bg-slate-50 transition-colors min-h-[56px]"
              >
                <span className="font-semibold text-brand-900 pr-8">
                  {faq.question}
                </span>
                <svg
                  className={`w-6 h-6 text-water-600 flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? 'transform rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {openIndex === index && (
                <div className="px-6 pb-4 text-slate-700 leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-lg text-brand-700 mb-4">Still have questions?</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="tel:+17272773366"
              className="inline-block bg-water-600 hover:bg-water-700 text-white font-bold py-3 px-8 rounded-lg transition-colors duration-200 min-h-[48px]"
            >
              <span className="mr-2">📞</span>
              Call Joe: (727) 277-3366
            </a>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-block bg-nature-600 hover:bg-nature-700 text-white font-bold py-3 px-8 rounded-lg transition-colors duration-200 min-h-[48px]"
            >
              <span className="mr-2">✉️</span>
              Email Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQ;
